import PropTypes from 'prop-types';

export const ImageType = PropTypes.shape({
  name: PropTypes.string,
  type: PropTypes.string,
  srcUrl: PropTypes.string
});

const DocumentType = PropTypes.shape({
  forms: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func
  ])),
  images: PropTypes.oneOfType([
    PropTypes.arrayOf(ImageType),
    ImageType
  ])
});

export const DocumentWizardPropTypes = {
  documents: PropTypes.oneOfType([
    PropTypes.arrayOf(DocumentType),
    DocumentType
  ]),
  documentSelectOn: PropTypes.bool,
  hideDocumentPreviewMobileWeb: PropTypes.bool,
  removeDocument: PropTypes.func
};

export const DocumentWizardDefaultProps = {
  documents: null,
  documentSelectOn: false,
  hideDocumentPreviewMobileWeb: false,
  removeDocument: null
};